import { 
    PUBLISH_FAIL, PUBLISH_REQUEST, PUBLISH_SUCCESS
  } from "../constant";
  
  const initialState = {
    publishData: 2,
    publishLoading: true
  }
  
  const publishReducer = (state = initialState, action) => {
    switch (action.type) {
      case PUBLISH_REQUEST:
        return { ...state, publishLoading: true }
  
      case PUBLISH_FAIL:
        return { ...state, publishLoading: false }
  
      case PUBLISH_SUCCESS:
        console.log('action?.payload', action?.payload?.[0].su_is_active);
        return {
          ...state,
          publishData: action?.payload?.[0].su_is_active,
          publishLoading: false
        }

      default:
        return state;
    }
  }
  
  export default publishReducer